export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden">
      {/* Background image with overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20gradient%20with%20soft%20terracotta%20peach%20and%20warm%20ivory%20tones%2C%20subtle%20organic%20wave%20patterns%20resembling%20fine%20textile%20weave%2C%20gentle%20luminous%20center%20fading%20to%20slightly%20deeper%20edges%2C%20airy%20ethereal%20atmosphere%20with%20delicate%20texture%20variation%2C%20minimal%20modern%20aesthetic%20suitable%20for%20text%20overlay%2C%20sophisticated%20warm%20neutral%20palette%20with%20quiet%20elegance%2C%20no%20objects%20or%20figures%20just%20atmospheric%20color%20fields&width=1800&height=1200&seq=hero-bg-v2&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/20"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 pt-16 md:pt-20">
        <div className="max-w-3xl">
          {/* Trust badges */}
          <div className="flex flex-wrap items-center gap-4 md:gap-6 mb-6 md:mb-8">
            <div className="flex items-center gap-2 text-white/90 text-xs md:text-sm">
              <i className="ri-refresh-line"></i>
              <span className="whitespace-nowrap">Updated Daily</span>
            </div>
            <div className="flex items-center gap-2 text-white/90 text-xs md:text-sm">
              <i className="ri-shield-check-line"></i>
              <span className="whitespace-nowrap">Safe Shopping</span>
            </div>
            <div className="flex items-center gap-2 text-white/90 text-xs md:text-sm">
              <i className="ri-verified-badge-line"></i>
              <span className="whitespace-nowrap">Verified Resources</span>
            </div>
            <div className="flex items-center gap-2 text-white/90 text-xs md:text-sm">
              <i className="ri-group-line"></i>
              <span className="whitespace-nowrap">Community Recommended</span>
            </div>
          </div>

          {/* H1 */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-heading font-extrabold text-white leading-tight tracking-tight">
            Kakobuy Spreadsheet
            <br />
            <span className="text-white/90 font-semibold">The Ultimate Resource Center 2026</span>
          </h1>

          {/* Subtitle */}
          <p className="mt-5 md:mt-6 text-base md:text-lg text-white/80 leading-relaxed max-w-lg">
            Discover the latest <strong className="text-white font-semibold">Kakobuy Spreadsheet</strong> links, trusted finds, shopping guides, and product recommendations — all updated daily for the smart shopper.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row items-start gap-3 mt-7 md:mt-8">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all hover:-translate-y-0.5 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-file-list-3-line text-lg"></i>
              Open Latest Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/90 text-foreground-900 font-semibold text-base hover:bg-white transition-all hover:-translate-y-0.5 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-shopping-bag-3-line text-lg"></i>
              Browse Product Categories
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}